import { observer } from 'mobx-react';
import * as React from 'react';
import { stylesheet } from "typestyle";
import OxygenLoggerSettings from './OxygenLoggerSettings';
import { Logger } from './Models';
import PHLoggerSettings from './PHLoggerSettings';


const css = stylesheet({
	reading: {
		borderRadius: '5px',
		display: 'inline-flex',
		flexDirection: 'row',
		fontSize: '2em',
		lineHeight: .95,
		padding: '3px',
	},
	readingError: {
		background: '#f50057',
		borderRadius: '5px',
		display: 'inline-flex',
		flexDirection: 'row',
		fontSize: '2em',
		lineHeight: '.95',
		padding: '3px',
	},
	symbol: {
		fontSize: '.5em',
		marginLeft: '1px',
		opacity: .5,
	},
	lastUpdated: {
		fontSize: '.6em',
		opacity: .5,
		paddingLeft: '3px',
	},
	loggerBox: {
		display: 'inline-flex',
		flexDirection: 'column',
		marginRight: '10px',
	},
	loggerBoxError: {
		display: 'inline-flex',
		flexDirection: 'column',
		marginRight: '10px',
	},
	loggerName: {
		fontSize: '.8em',
		opacity: .5,
	},
	column: {
		display: 'inline-flex',
		flexDirection: 'column',
	},
	row: {
		display: 'inline-flex',
		flexDirection: 'row',
	},
	originalReading: {
		fontSize: '.4em',
		marginLeft: '1px',
		opacity: .5,
		textAlign: 'right',
	},
})

@observer
export default class LoggerBox extends React.Component<{
	logger: Logger,
	oxygenMinimum: number
}> {

	redrawInterval: any = null

	componentDidMount() {
		// Force a redraw to have the 'last updated' updated
		this.redrawInterval = setInterval(() => {
			this.render()
		}, 10000)
	}
	componentWillUnmount() {
		clearInterval(this.redrawInterval)
	}

	render() {
		const { logger, oxygenMinimum } = this.props;

		return (
			<div className={css.loggerBox}>
				<div className={css.loggerName}>{logger.name}</div>

				{logger.monitorOxygen && <div className={(logger.oxygen < oxygenMinimum) ? css.readingError : css.reading}>
					<div className={css.column}>
						<div>{logger.oxygen.toFixed(2)}</div>
						{logger.oxygenOriginalReading !== undefined && <div className={css.originalReading}>{logger.oxygenOriginalReading.toFixed(5)} V</div>}
					</div>
					<div>
						<div className={css.symbol}>
							O<sub>2</sub>
						</div>
					</div>
					{logger.isOxygenCalibratable && <OxygenLoggerSettings logger={logger} />}
				</div>}

				{logger.monitorDepth && <div className={css.reading}>
					<div className={css.column}>
						<div>{logger.depth.toFixed(2)}</div>
						{logger.depthOriginalReading !== undefined && <div className={css.originalReading}>{logger.depthOriginalReading.toFixed(5)} V</div>}
					</div>
					<div>
						<div className={css.symbol}>
							m
						</div>
					</div>
				</div>}

				{logger.monitorPH && <div className={css.reading}>
					<div className={css.column}>
						<div>{logger.pHReading.toFixed(3)}</div>
					</div>
					<div>
						<div className={css.symbol}>
							pH
						</div>
					</div>
					<PHLoggerSettings logger={logger} />
				</div>}

				{logger.monitorSalinity && <div className={css.reading}>
					<div className={css.column}>
						<div>{logger.salinityReading.toFixed(3)}</div>
					</div>
					<div>
						<div className={css.symbol}>
							‰
						</div>
					</div>
				</div>}

				{logger.monitorWaterCurrent && <div className={css.reading}>
					<div className={css.column}>
						<div>{logger.waterCurrentReading.toFixed(3)}</div>
					</div>
					<div>
						<div className={css.symbol}>
							%
						</div>
					</div>
				</div>}

				{logger.monitorTemperature && <div className={css.reading}>
					<div>{logger.temperature.toFixed(2)}</div>
					<div className={css.symbol}>
						&deg;C
					</div>
				</div>}

				<div className={css.lastUpdated}>{logger.lastUpdated}</div>
			</div>

		);
	}
}


// WEBPACK FOOTER //
// ./src/LoggerBox.tsx